import { DialogService, GridAction } from '@eforall/dashboard';
import { DialogMode, EngagementFollowUp } from '@interfaces';
import { BaseEngagementService } from '../../../../../services';
import { FollowUpEditorDialog, FollowUpEditorDialogData, FollowUpViewerDialog, FollowUpViewerDialogData, PersonDialog, PersonDialogData } from '../../../../widget';

export function getActions(pageService: BaseEngagementService, dialogService: DialogService) {

	const actions: GridAction<EngagementFollowUp>[] = [
		{
			iconClass: 'fa-regular fa-eye',
			label: 'Open Follow-up',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const dialogData: FollowUpViewerDialogData = {
					followUpId: rows[0]!.followUpId,
					staffRoleId: pageService.staffRoleId()!
				};
				await dialogService.showCustom(FollowUpViewerDialog, { data: dialogData }, 600, 600);
				await pageService.areaService?.reloadData();
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Edit Follow-up',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const dialogData: FollowUpEditorDialogData = {
					mode: DialogMode.EDIT,
					followUpId: rows[0]!.followUpId,
				};
				await dialogService.showCustom(FollowUpEditorDialog, { data: dialogData }, 650, 750);
				await pageService.areaService?.reloadData();
			}
		},
		{
			iconClass: 'fa-regular fa-user',
			label: 'Explore Person',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.person.id, toEdit: false } }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-message-arrow-up-right',
			label: 'View All Engagements',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const dialogData: PersonDialogData = { personId: rows[0]!.person.id, toEdit: false, tab: 'engagements' };
				await dialogService.showCustom(PersonDialog, { data: dialogData }, 800, 800);
			}
		}
	];

	return actions;
}